/// <reference types="./events.d.mts" />
import * as $unsafe from "../../../../common_common/gleam/unsafe.mjs";
import * as $decode from "../../../../gleam_stdlib/gleam/dynamic/decode.mjs";
import * as $effect from "../../../../lustre/lustre/effect.mjs";
import * as $event from "../../../../lustre/lustre/event.mjs";

const event_name = "freyja-traverse";

export function traverse(msg) {
  let msg$1 = $unsafe.coerce(msg);
  return $event.emit(event_name, msg$1);
}

export function passthrough() {
  let _pipe = $event.on(
    event_name,
    $decode.field(
      "detail",
      $decode.dynamic,
      (detail) => {
        let detail$1 = $unsafe.coerce(detail);
        return $decode.success(detail$1);
      },
    ),
  );
  return $event.stop_propagation(_pipe);
}
